// import React from 'react';
// import tractorBg from '../../../assets/styles/tractor_bg.png'; // Using slider1.png as it appears to have a tractor image

// const RetailNetworkSection = () => {
//     return (
//         <section className="py-12 px-4">
//             <div className="max-w-[1280px] mx-auto">
//                 <div className="relative rounded-3xl overflow-hidden">
//                     {/* Background Image */}
//                     <div className="relative h-[400px] md:h-[500px]">
//                         <img
//                             src={tractorBg}
//                             alt="Tractor in field"
//                             className="w-full h-full object-cover"
//                         />

//                         {/* Overlay for better text readability */}
//                         <div className="absolute inset-0 bg-black/20"></div>

//                         {/* Content */}
//                         <div className="absolute inset-0 flex flex-col p-8 md:p-[40px]">
//                             <div className="max-w-md top-1/2">
//                                 <h2 className="text-3xl md:text-4xl font-[LTWave] font-bold text-white mb-4 leading-tight">
//                                     Become Part Of <br />
//                                     Our Growing Retail <br /> 
//                                     Network Today.
//                                 </h2>
//                             </div>

//                             <div className="absolute right-0 bottom-0 md:p-[40px]">
//                                     <a
//                                         href="#contact"
//                                         className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm font-inter font-regular text-[14px] text-white px-6 py-3 rounded-2xl hover:bg-white/30 transition-all shadow-cyan-500/50"
//                                         >
//                                         Contact us Now
//                                         <svg
//                                             xmlns="http://www.w3.org/2000/svg"
//                                             className="h-5 w-5"
//                                             viewBox="0 0 20 20"
//                                             fill="currentColor"
//                                         >
//                                             <path
//                                                 fillRule="evenodd"
//                                                 d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
//                                                 clipRule="evenodd"
//                                             />
//                                         </svg>
//                                     </a>
//                                 </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default RetailNetworkSection;



import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import tractorBg from '../../../assets/styles/tractor_bg.png'; // Using slider1.png as it appears to have a tractor image

const RetailNetworkSection = () => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <section className="py-12 px-4">
            <div className="max-w-[1280px] mx-auto">
                <div className="relative rounded-3xl overflow-hidden">
                    {/* Background Image */}
                    <div 
                        className="relative h-[400px] md:h-[500px] overflow-hidden transition-all duration-500"
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <img
                            src={tractorBg}
                            alt="Tractor spraying crops in a farm field"
                            className={`w-full h-full object-cover transition-transform duration-700 ${isHovered ? 'scale-110' : 'scale-100'}`}
                        />

                        {/* Overlay for better text readability */}
                        <div className={`absolute inset-0 bg-black/20 transition-opacity duration-500 ${isHovered ? 'bg-black/20' : 'bg-black/10'}`}></div>

                        {/* Content */}
                        <div className="absolute inset-0 flex flex-col p-8 md:p-[40px]">
                            <div className="max-w-md top-1/2">
                                <h2 className="text-3xl md:text-4xl font-[LTWave] font-bold text-white mb-4 leading-tight">
                                    Become Part Of <br />
                                    Our Growing Retail <br /> 
                                    Network Today.
                                </h2>
                            </div>

                            <div className="absolute right-0 bottom-0 md:p-[40px]">
                                    <Link
                                        to="/contact"
                                        className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm font-inter font-regular text-[14px] text-white px-6 py-3 rounded-2xl hover:bg-white/30 transition-all shadow-cyan-500/50"
                                        >
                                        Contact us Now
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-5 w-5"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </Link>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RetailNetworkSection;
